import { LineChart } from "@mui/x-charts";

export default function SimpleLineChart({ series = [], xAxis = [] }) {
  return <LineChart series={series} xAxis={xAxis}></LineChart>;
}
